module.exports = __webpack_public_path__ + "img/step-9.ccbd4cb1.jpg";